/* eslint-disable max-len */
import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'

// Actions
import {storePayload} from '../actions/storePayload'

// Components
import {Icon, Slider} from '@lazarusai/forms-ui-components'

// Styles
import '../styles/View.css'
import '../styles/Image.css'

function ImageRender(props) {
  const [fileURL, setFileURL] = useState(null)
  const [rotations, setRotations] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [imageWidth, setImageWidth] = useState(null)
  const [imageHeight, setImageHeight] = useState(null)

  const fileIndex = 0 // file index placeholder

  const rotateStyles = [
    'rotate(0deg)',
    'rotate(90deg) translateY(-100%)',
    'rotate(180deg) translateY(-100%) translateX(-100%)',
    'rotate(270deg) translateX(-100%)',
  ]

  const smallRotateStyles = [
    'rotate(0deg)',
    'rotate(90deg) translateY(-100%)',
    'rotate(180deg) translateY(-100%) translateX(-100%)',
    'rotate(270deg) translateX(-100%)',
  ]

  useEffect(() => {
    if (props.file) {
      setFileURL(URL.createObjectURL(props.file))
      setRotations(0)
      setZoom(1)
      const fileReader = new FileReader()
      fileReader.readAsDataURL(props.file)
      fileReader.onload = (e) => {
        const image_obj = new Image()
        image_obj.src = e.target.result
        image_obj.onload = function() {
          const maxWidth = document.getElementById('image-container').clientWidth
          const maxHeight = document.getElementById('image-container').clientHeight
          const heightWidthRatio = this.height/this.width
          if (false && heightWidthRatio > maxHeight/maxWidth) {
            setImageWidth(parseInt(maxHeight * (1/heightWidthRatio)))
            setImageHeight(maxHeight)
          } else {
            setImageHeight(parseInt(maxWidth * heightWidthRatio))
            setImageWidth(maxWidth)
          }
        }
      }
    }
  }, [props.file])

  useEffect(() => {
    const wrapEl = document.getElementById('doc-image-container')
    if (wrapEl) {
      wrapEl.style.height = `${rotations % 2 === 0 ? imageHeight * zoom : imageWidth * zoom}px`
      wrapEl.style.width = `${rotations % 2 === 0 ? imageWidth * zoom : imageHeight * zoom}px`
    }
  }, [rotations, zoom])

  return (
    <div className='render-container'>
      <div className='zoom'>
        <Slider
          type={4}
          theme={'dark'}
          onChangeZoom={(e) => {
            const val = parseInt(e.target.value)
            setZoom(3 ** (val/50) / 3)
          }}
        />
      </div>
      <div className='rotate-icon'>
        <Icon
          icon={'refresh-outline'}
          key={'rotate-icon'}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            setRotations((rotations + 1)%4)
          }}
        />
      </div>
      <div id='image-container'>
        {props.file &&
            <div
              id={'pdf-keyValuePairs' + fileIndex}
              style={{width: '100%'}}
            >
              {/* this is the image specific section */}
              <div
                className='doc-image-container'
                // onClick={onFileClick}
                id='doc-image-container'
              >
                <img
                  className={`doc-image rotate`}
                  src={fileURL}
                  alt=''
                  style={{
                    width: `${Math.round(zoom * imageWidth)}px`,
                    height: `${Math.round(zoom * imageHeight)}px`,
                    transform: `${rotateStyles[rotations]}`,
                  }}
                />
                {fileURL &&
                    <canvas
                      id={'image-canvas-keyValuePairs-' + fileIndex}
                      className={
                        // i === selectedFileIndex ?
                        true ?
                            `image-canvas rotate ${zoom < 1 ? 'small' : ''}rotate${rotations}` :
                            'image-canvas opacity-0'
                      }
                      height={Math.round(imageHeight)}
                      width={Math.round(imageWidth)}
                      style={{
                        // width: `${zoom * 100}%`,
                        height: `${Math.round(zoom * imageHeight)}px`,
                        width: `${Math.round(zoom * imageWidth)}px`,
                        transform: `${zoom < 1 ? smallRotateStyles[rotations] : rotateStyles[rotations]}`,
                      }}
                    />
                }
              </div>
            </div>
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  pagesData: state.userReducer.pagesData,
  dataRender: state.userReducer.dataRender,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(ImageRender)

